import { Button, Form, Select } from 'antd';
import { postApi, putApi } from 'apis';
import InputWithLabelAndSvg from 'components/Global/InputWithLabel';
import { FORMDATA } from 'constants/Data';
import React, { FC, useEffect, useState } from 'react';
import { toastText } from 'utils/utils';
import styles from './index.module.scss';
import { SideDrawerBodyProps } from './types';

const AddUserBody: FC<SideDrawerBodyProps> = (props) => {
	// Inits
	const { addUserFields } = FORMDATA;
	const {
		closeDrawerByAnimation,
		editSelectedUser,
		roleOptions,
		fetchUsers,
	} = props;
	const [form] = Form.useForm();
	const [userFields, setUserFields] = useState(addUserFields);

	// State Management
	const [selectedRole, setSelectedRole] = useState(
		editSelectedUser ? editSelectedUser?.roleId : null
	);
	const [isSelected, setIsSelected] = useState<boolean>();
	const [loading, setLoading] = useState<boolean>();

	const editData = {
		...editSelectedUser,
		fullName: editSelectedUser?.name || '',
	};

	const inviteUser = async (finalData: any) => {
		try {
			setLoading(true);
			await postApi('/user/invite-user', finalData);
			toastText('User invited successfully', 'success');
		} catch (err: any) {
			const errorMessage =
				err?.response?.data?.message ||
				'Something went wrong when trying to invite';
			toastText(errorMessage, 'error');
		} finally {
			setLoading(false);
		}
	};

	const updateUser = async (finalData: any) => {
		try {
			setLoading(true);
			await putApi('/user', finalData);
		} catch (err) {
			toastText('Something went wrong in updating user', 'error');
		} finally {
			setLoading(false);
		}
	};

	const onFinish = async (values: any, buttonType = 'Save') => {
		if (editSelectedUser) {
			const fullName = (values.fullName as string).trim();
			let data: any = {
				userId: editSelectedUser?.userId,
				fullName,
			};

			if (selectedRole) {
				data = {
					...data,
					roleId: selectedRole,
				};

				await updateUser(data);
				fetchUsers();
				closeDrawerByAnimation();
			}
		} else {
			if (selectedRole) {
				setIsSelected(true);
				const finalData = {
					email: values.email,
					role: selectedRole,
				};
				await inviteUser(finalData);
				fetchUsers();
				closeDrawerByAnimation();
			} else {
				selectedRole ? setIsSelected(true) : setIsSelected(false);
			}
		}
	};

	// If form fails
	const onFinishFailed = () => {
		if (selectedRole) {
			setIsSelected(true);
		} else {
			setIsSelected(false);
		}
	};

	useEffect(() => {
		if (editSelectedUser) {
			setUserFields(addUserFields);
		} else {
			setUserFields(
				addUserFields.filter((item) => item.id !== 'fullName')
			);
		}
	}, [editSelectedUser]);

	// JSX
	return (
		<div className={styles['side-drawer-body']}>
			<Form
				form={form}
				name="basic"
				initialValues={editData}
				onFinish={onFinish}
				onFinishFailed={onFinishFailed}
				autoComplete="off"
				layout="vertical"
				labelAlign="left"
				className={styles['side-drawer-form']}
			>
				<div className={styles['side-drawer-form__inputs']}>
					{userFields.map((singleField: any) => {
						return (
							<React.Fragment key={singleField.id}>
								{singleField.id === 'phone' && (
									<Form.Item
										className="side-drawer-form__role"
										name={singleField.name}
									>
										<label
											className={
												styles[
													'side-drawer-form__role--label'
												]
											}
										>
											{singleField.title}{' '}
											{singleField?.required && (
												<span className="required-color">
													*
												</span>
											)}
										</label>
									</Form.Item>
								)}
								{singleField.id !== 'roleName' &&
									singleField.id !== 'phone' && (
										<InputWithLabelAndSvg
											singleUserInput={singleField}
											disabled={
												singleField?.name === 'email' &&
												!!editSelectedUser
											}
										/>
									)}
								{singleField.id === 'roleName' && (
									<Form.Item
										className="side-drawer-form__role"
										name={singleField.name}
									>
										<label
											className={
												styles[
													'side-drawer-form__role--label'
												]
											}
										>
											{singleField.title}{' '}
											{singleField?.required && (
												<span className="required-color">
													*
												</span>
											)}
										</label>

										<Select
											placeholder="Select Role"
											className={
												styles[
													'side-drawer-form__role--select'
												]
											}
											size="large"
											disabled={false}
											value={selectedRole}
											onSelect={(role) => {
												setSelectedRole(role);
												setIsSelected(true);
											}}
										>
											{/* <Select.Option>Test</Select.Option> */}
											{roleOptions?.map(
												(role: any, key: number) => {
													return (
														<Select.Option
															value={role?.id}
															key={
																role?.id ||
																role?.name
															}
														>
															{role?.name}
														</Select.Option>
													);
												}
											)}
										</Select>
										{isSelected === false && (
											<p className="ant-form-item-explain-error">
												Please select role
											</p>
										)}
									</Form.Item>
								)}
							</React.Fragment>
						);
					})}
				</div>
				<div className={styles['side-drawer-form__buttons']}>
					<Form.Item>
						<Button
							htmlType="submit"
							className={`${styles['side-drawer-form__buttons--edit']} `} //isAddUserLoading
							loading={loading}
							disabled={loading}
						>
							Save
						</Button>
					</Form.Item>
					<Form.Item>
						<Button
							htmlType="reset"
							className={`${styles['side-drawer-form__buttons--cancel']}`}
							onClick={closeDrawerByAnimation}
							disabled={loading}
						>
							Cancel
						</Button>
					</Form.Item>
				</div>
			</Form>
		</div>
	);
};

export default AddUserBody;
